/* Encart d'achat des articles de blog.

   Deux comportements :
   1. Ajout au panier sans quitter l'article — même protocole que les
      recommandations du panier (/cart/add.js puis événement `cart:update`,
      que le thème écoute pour rafraîchir son tiroir).
   2. La barre mobile n'apparaît qu'une fois la lecture engagée, et s'efface
      dès qu'une carte produit du même produit est à l'écran : deux offres du
      même bijou visibles en même temps, c'est du bruit, pas de la relance. */

(() => {
  /* Un article de ce blog fait 25 000 px de haut sur mobile : déclencher la
     barre à un pourcentage de lecture la ferait apparaître après 3 000 px, soit
     quatre écrans. On l'affiche dès que le lecteur a dépassé l'en-tête, c'est-
     à-dire dès qu'il lit vraiment. */
  const HEADER_PASSED_RATIO = 0.4;

  const addToCart = async (box) => {
    const button = box.querySelector('[data-ag-buybox-add]');
    const label = box.querySelector('[data-ag-buybox-label]');
    const variantField = box.querySelector('[data-ag-buybox-variant]');
    if (!button || !variantField) return;

    const variantId = variantField.value;
    const original = label ? label.textContent : '';
    button.disabled = true;
    if (label) label.textContent = 'Ajout…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!response.ok) throw new Error('add failed');

      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'ag-blog-buybox',
            data: { source: 'ag-blog-buybox', itemCount: cart.item_count },
          },
        })
      );

      box.classList.add('is-added');
      if (label) label.textContent = 'Ajouté ✓';

      /* Le lecteur vient d'ajouter : on lui donne la suite tout de suite.
         Sans ce relais, il faut retrouver l'icône panier en haut de page —
         sur mobile, c'est là que l'on perd la commande. */
      const follow = box.querySelector('[data-ag-buybox-follow]');
      if (follow) follow.hidden = false;

      // Mesurable : l'article devient une source de vente identifiable.
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'blog_add_to_cart',
          product_handle: box.dataset.productHandle,
          context: box.classList.contains('ag-buybox--bar') ? 'bar-mobile' : 'rail-desktop',
        });
      }

      // Le tiroir s'ouvre de lui-même (auto_open_cart_drawer) : le relais redevient discret
      window.setTimeout(() => {
        box.classList.remove('is-added');
        if (label) label.textContent = original;
        if (follow) follow.hidden = true;
        button.disabled = false;
      }, 3200);
    } catch (error) {
      if (label) label.textContent = 'Réessayer';
      button.disabled = false;
      window.setTimeout(() => { if (label && label.textContent === 'Réessayer') label.textContent = original; }, 3000);
      console.error('buybox: ajout au panier impossible', error);
    }
  };

  const setupBar = (bar) => {
    const article = document.querySelector('.ag-article-content');
    if (!article) return;

    // Toute carte produit déjà présente dans l'article et pointant vers le
    // même produit : tant qu'elle est visible, la barre s'efface.
    const handle = bar.dataset.productHandle;
    const rivals = [...document.querySelectorAll(`a[href*="/products/${handle}"]`)]
      .map((link) => link.closest('.ag-pierre-reco, #ag-product-card, .ag-related-product, .ag-buybox--rail'))
      .filter((node, index, list) => node && !node.classList.contains('ag-buybox--bar') && list.indexOf(node) === index);

    let rivalVisible = false;
    if (rivals.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.dataset.agVisible = entry.isIntersecting ? '1' : '';
          });
          rivalVisible = rivals.some((node) => node.dataset.agVisible === '1');
          bar.classList.toggle('is-muted', rivalVisible);
        },
        { rootMargin: '-10% 0px -10% 0px' }
      );
      rivals.forEach((node) => observer.observe(node));
    }

    let ticking = false;
    const update = () => {
      ticking = false;
      const rect = article.getBoundingClientRect();
      const started = rect.top < window.innerHeight * HEADER_PASSED_RATIO;
      const finished = rect.bottom < window.innerHeight * 0.5;
      bar.classList.toggle('is-visible', started && !finished);
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    update();
  };

  /* Le sommaire est ouvert par défaut : utile sur ordinateur, où il vit dans la
     colonne, mais sur mobile il s'insère dans le flux et ajoute 350 px avant le
     premier paragraphe. On le referme — le lecteur qui le veut le déplie. */
  const collapseTocOnMobile = () => {
    if (window.matchMedia('(min-width: 990px)').matches) return;
    const toc = document.querySelector('.ag-toc__details');
    if (toc) toc.open = false;
  };

  /* Le bandeau « trouver votre ange gardien » est rendu avant le contenu, alors
     que son commentaire d'origine vise « le moment où le lecteur vient
     d'obtenir sa réponse ». Résultat mesuré sur mobile : 434 px de plus avant
     le premier paragraphe, et une proposition faite à quelqu'un qui n'a encore
     rien lu. On le repose après la troisième section — la réponse est donnée,
     l'attention est disponible. */
  const moveAngelCtaIntoContent = () => {
    const cta = document.querySelector('.ag-acta');
    const article = document.querySelector('.ag-article-content');
    if (!cta || !article) return;

    const headings = article.querySelectorAll('h2');
    const anchor = headings[2] || headings[1];
    if (!anchor) return;

    anchor.parentNode.insertBefore(cta, anchor);
  };

  const boot = () => {
    collapseTocOnMobile();
    moveAngelCtaIntoContent();
    document.querySelectorAll('[data-ag-buybox]').forEach((box) => {
      const button = box.querySelector('[data-ag-buybox-add]');
      if (button) button.addEventListener('click', () => addToCart(box));
      // Le prix suit la variante choisie (les perles 8 et 10 mm coûtent plus cher)
      const select = box.querySelector('select[data-ag-buybox-variant]');
      const price = box.querySelector('[data-ag-buybox-price]');
      if (select && price) {
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];
          if (option && option.dataset.price) price.textContent = option.dataset.price;
        });
      }
      if (box.classList.contains('ag-buybox--bar')) setupBar(box);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
